import React from 'react'
import NumberFormat from '../../../components/NumberFormat'

const Bmi = ({cheque}) => {
    return (
        <tr className='ligne' >
            <td>
                <div id=''
                    className="relative overflow-hidden border border-gray-300 cheque-print"
                    style={{
                        width: '165mm',
                        height: '75mm',
                        backgroundImage: 'url(/bmi.png)',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center top'
                    }}
                >
                    {/* Montant (en haut à droite) */}
                    <div className="absolute font-times top-5 right-24 text-lg font-bold text-black">
                        <NumberFormat valeur={cheque.montant} />
                    </div>

                    {/* À l'ordre de */}
                    <div className="absolute flex flex-wrap w-[97mm] h-40 leading-[1.7]   font-times left-[29mm] top-[20mm] text-sm font-semibold">
                        {cheque.montantLettre}
                    </div>

                    

                    {/* À l'ordre de */}
                    <div className="absolute font-times left-[20mm] top-[33mm] text-sm font-semibold">
                        {cheque.nom}
                    </div>

                    {/* Numéro de chèque */}
                    {/* <div className="absolute left-[48mm] top-[33mm] text-sm">

                            </div> */}

                    {/* Compte n° */}
                    {/* <div className="absolute left-[48mm] top-[38mm] text-sm">

                            </div> */}

                    {/* Lieu et date */}
                    <div className="absolute font-times left-[90mm] top-[39mm] text-xs font-semibold">
                        {cheque.lieu}
                    </div>
                    <div className="absolute font-times left-[131mm] top-[39mm] text-xs font-semibold">
                        {cheque.dateCheque}
                    </div>

                    {/* Signature */}
                    <div className="absolute font-times right-[23mm] bottom-[10mm] text-sm font-semibold">

                    </div>
                </div>
            </td>

        </tr>
    )
}

export default Bmi